import React, { useContext } from "react";
import { AuthContext } from "../state/AuthContext";
import AdminDashboardPage from "./AdminDashboardPage";
import TeamDashboardPage from "./TeamDashboardPage";

export default function DashboardPage() {
  const { user } = useContext(AuthContext);

  if (user?.role === "admin") {
    return <AdminDashboardPage />;
  }

  return <TeamDashboardPage />;
}
